import React, { useEffect, useState } from "react";
import {
  IoAlertCircleOutline,
  IoTimeOutline,
  IoCheckmarkCircleOutline,
  IoStatsChartOutline,
} from "react-icons/io5";
import { getIssueAnalytics } from "../../../../services/issueLogService";

/**
 * Four stat cards for project-level issue analytics.
 * Ports reno-portal's ProjectIssueAnalytics.jsx.
 */
export default function ProjectIssueAnalytics({ projectId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!projectId) return;
    let cancelled = false;
    setLoading(true);
    setError(false);
    getIssueAnalytics(projectId)
      .then((res) => {
        if (cancelled) return;
        setData(res || null);
      })
      .catch(() => {
        if (cancelled) return;
        setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [projectId]);

  if (error) return null;

  const val = (k) => {
    if (loading && !data) return "—";
    const n = data?.[k];
    return typeof n === "number" ? n : 0;
  };

  const cards = [
    {
      label: "Open Issues",
      value: val("total_open"),
      color: "#dc2626",
      bg: "rgba(239, 68, 68, 0.1)",
      Icon: IoAlertCircleOutline,
    },
    {
      label: "In Progress",
      value: val("total_in_progress"),
      color: "#ea580c",
      bg: "rgba(249, 115, 22, 0.1)",
      Icon: IoTimeOutline,
    },
    {
      label: "Resolved",
      value: val("total_resolved"),
      color: "#16a34a",
      bg: "rgba(34, 197, 94, 0.1)",
      Icon: IoCheckmarkCircleOutline,
    },
    {
      label: "Total Issues",
      value: val("total_issues"),
      color: "#0d0d0e",
      bg: "#f3f4f6",
      Icon: IoStatsChartOutline,
    },
  ];

  return (
    <>
      <style>{`
        @media (max-width: 899px) {
          .issue-analytics-grid {
            grid-template-columns: 1fr 1fr !important;
          }
        }
      `}</style>
    <div
      className="issue-analytics-grid"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        gap: 12,
        padding: "0 4px",
        marginBottom: 8,
      }}
    >
      {cards.map((c) => (
        <div
          key={c.label}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: 16,
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            background: "#fff",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 4, minWidth: 0 }}>
            <span style={{ fontSize: 12, color: "#6b7280", fontWeight: 500 }}>
              {c.label}
            </span>
            <span
              style={{
                fontSize: 24,
                fontWeight: 600,
                color: c.color,
                fontFamily: "Inter Tight",
                lineHeight: 1.1,
              }}
            >
              {c.value}
            </span>
          </div>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 9999,
              background: c.bg,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <c.Icon size={22} color={c.color} />
          </div>
        </div>
      ))}
    </div>
    </>
  );
}
